import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleOptionsField from '../../../../../../ReusableFormFields/MultipleOptionsField'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getHeadlineData } from './helpers'

import { googleAssetFieldType } from '../../../../../../../constants/ads'

import { HEADLINES_LIST } from '../../../../fields'
import { getInitialValues, headlineMaxLength, validationSchema } from './fields'

const HeadlinesSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalHeadlineAssets = useMemo(() => getHeadlineData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalHeadlineAssets), [originalHeadlineAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalHeadlineAssets,
    fieldType: googleAssetFieldType.HEADLINE,
    sectionValueKey: HEADLINES_LIST,
    isInternalAssetGroup,
    assetGroupId,
    initialValues,
    validationSchema,
    title,
    adAccount
  })

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      {...formProps}
    >
      <MultipleOptionsField
        fieldLabel="Headline"
        fieldMaxLength={headlineMaxLength}
        listFieldName={HEADLINES_LIST}
        formik={purifiedFormik}
        minListQuantity={3}
      />
    </EditForm>
  )
}

export default HeadlinesSectionForm
